module.exports = __webpack_public_path__ + "img/news18_1.52dbe266.jpg";